import Auth from './modules/auth';

export default {
    modules:{
        access: Auth
    }
};